export const environment = {
  production: true,
  sentry: true,
  recaptchaKey: '6LcoWfolAAAAAOzWso64KJ2ubFjC-W4Jfb_QNSaJ',
};
